export type ForwardEmailEnvironment = 'qa' | 'stage' | 'prod';

const FORWARD_EMAIL_DOMAIN = 'customerportal.help';

export function getForwardEmailEnvironment(): ForwardEmailEnvironment {
  const hostname = (window.location && window.location.hostname || '').toLowerCase();

  if (hostname.includes('qa') || hostname.includes('dev')) {
    return 'qa';
  }

  if (hostname.includes('stage')) {
    return 'stage';
  }

  return 'prod';
}

export function generateForwardEmail(agencyId: number, environment?: ForwardEmailEnvironment): string {
  if (!agencyId || agencyId <= 0) {
    throw new Error(`Invalid agencyId: ${agencyId}`);
  }

  const env = environment || getForwardEmailEnvironment();

  let emailPrefix: string;
  if (env === 'qa') {
    emailPrefix = `agency${agencyId}-qa-forward`;
  } else if (env === 'stage') {
    emailPrefix = `agency${agencyId}-stage-forward`;
  } else {
    emailPrefix = `agency${agencyId}-forward`;
  }

  return `${emailPrefix}@${FORWARD_EMAIL_DOMAIN}`;
}
